import linkdin from "../images/SocialMediaIcons/linkdin round.png";
import github from "../images/SocialMediaIcons/github round.png";
import Instagram from "../images/SocialMediaIcons/instagram round.png";
import Facebook from "../images/SocialMediaIcons/facebook.png";
import Snapchat from "../images/SocialMediaIcons/snapchat round.png";

export const bio =
  "I’m a multi-talented and self-driven creator who loves turning ideas into powerful digital solutions. Whether it’s crafting smooth user interfaces, architecting scalable backend systems, or solving complex challenges, I enjoy every part of the journey. I believe in learning every day, building with purpose, and collaborating with people who aim high. My mission is simple: use my skills to build meaningful experiences while growing as an individual and contributing to the success of my team or organization. If you’re looking for someone passionate, reliable, and always ready to push boundaries—let’s team up and build something impactful.";

export const professionWords = [
  "Full Stack Developer",
  "Software Developer",
  "Web Developer",
  "Frontend Developer",
  "Backend Developer",
  "Mobile App Developer",
  "React Developer",
  "Next.js Developer",
  "Node.js Developer",
  "UI/UX Enthusiast",
  "Tech Enthusiast",
  "Programmer",
  "Software Engineer",
  "Problem Solver",
  "Tech Innovator",
  "Freelancer",
  "Creator",
  "Designer",
  "Gamer",
];

export const socialMediaHandle = [
  {
    name: "Linkdin",
    image: linkdin,
    link: "https://www.linkedin.com/in/kuldeep-kumar-485a13252/",
  },
  { name: "github", image: github, link: "https://github.com/Kuldeep-Angural" },
  {
    name: "Instagram",
    image: Instagram,
    link: "https://www.instagram.com/kuldeep__angural/",
  },
  {
    name: "Facebook",
    image: Facebook,
    link: "https://www.facebook.com/profile.php?id=100010206819115&mibextid=ZbWKwL",
  },
  {
    name: "Snapchat",
    image: Snapchat,
    link: "https://www.snapchat.com/add/navv_saab?share_id=dwzB-kiYAak&locale=en-GB",
  },
];

export const menu = [
  {
    name: "resume",
    links:
      "https://docs.google.com/document/d/1yID41mdr4FdbQ9OJA3w3D22uQtTugJ0ZrNmUOB6MBGs/edi",
  },

  { name: "github", link: "https://github.com/KuldeepKumarAngural" },
  {
    name: "Linkedin",
    link: "https://www.linkedin.com/in/kuldeep-kumar-485a13252/",
  },
];
